export function getCommentCount(poem) {
  if (typeof poem?.commentCount === "number") return poem.commentCount;
  if (!Array.isArray(poem?.comments)) return 0;
  return poem.comments.reduce(
    (total, comment) => total + 1 + (comment.replies?.length || 0),
    0
  );
}
